// Helpers puros de cotizaciones. `calcularTotales` es el ESPEJO en el navegador
// de la función SQL guardar_cotizacion (para mostrar los totales en vivo). El
// número que manda no se guarda: el servidor SIEMPRE recalcula y valida.
// Se trabaja en centavos (enteros) para evitar errores de coma flotante.

export const ESTADOS_COTIZACION = [
  { clave: 'borrador', nombre: 'Borrador', color: '#6B7280', bg: '#F3F4F6' },
  { clave: 'enviada', nombre: 'Enviada', color: '#1D4ED8', bg: '#DBEAFE' },
  { clave: 'vista', nombre: 'Vista por el cliente', color: '#7C3AED', bg: '#EDE9FE' },
  { clave: 'aprobada', nombre: 'Aprobada', color: '#047857', bg: '#D1FAE5' },
  { clave: 'rechazada', nombre: 'Rechazada', color: '#B91C1C', bg: '#FEE2E2' },
  { clave: 'vencida', nombre: 'Vencida', color: '#B45309', bg: '#FEF3C7' },
  { clave: 'cancelada', nombre: 'Cancelada', color: '#6B7280', bg: '#F3F4F6' },
  { clave: 'convertida', nombre: 'Convertida en venta', color: '#065F46', bg: '#A7F3D0' },
];

export function estadoInfo(clave) {
  return ESTADOS_COTIZACION.find((e) => e.clave === clave) || ESTADOS_COTIZACION[0];
}

// Enlace público que se le comparte al cliente (abre sin cuenta). `ref` es el
// código corto (o el token viejo). La ruta /vc/<ref> genera la tarjeta de vista
// previa con la marca del negocio y redirige a la página real.
export function urlCotizacionPublica(ref) {
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return `${base}/vc/${ref}`;
}

const cent = (n) => Math.round((Number(n) || 0) * 100);

// items: [{ cantidad, precio_unitario, descuento, impuesto_pct }]
// Devuelve montos en unidades de moneda (2 decimales) + los totales por línea.
export function calcularTotales(items = [], descuentoGlobal = 0, anticipo = 0) {
  let subtotalC = 0;
  let impuestoC = 0;
  const lineas = (items || []).map((it) => {
    // precio (en centavos) × cantidad (real), redondeado al centavo = igual que
    // round(precio*cantidad, 2) del servidor.
    const brutoCent = Math.round(cent(it.precio_unitario) * (Number(it.cantidad) || 0));
    let subC = brutoCent - cent(it.descuento);
    if (subC < 0) subC = 0;
    const impC = Math.round((subC * (Number(it.impuesto_pct) || 0)) / 100);
    const totC = subC + impC;
    subtotalC += subC;
    impuestoC += impC;
    return { subtotal: subC / 100, impuesto: impC / 100, total: totC / 100 };
  });

  const descGlobalC = Math.max(cent(descuentoGlobal), 0);
  let totalC = subtotalC + impuestoC - descGlobalC;
  if (totalC < 0) totalC = 0;
  const saldoC = totalC - cent(anticipo);

  return {
    subtotal: subtotalC / 100,
    impuesto: impuestoC / 100,
    descuento: descGlobalC / 100,
    total: totalC / 100,
    anticipo: (Number(anticipo) || 0),
    saldo: saldoC / 100,
    lineas,
  };
}
